export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6450.044db87a.jpg";